export const getIsHubLoading = state => state.hub.hub.isHubLoading;
